"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/config/browser");
var urljoin = require("url-join");
var internal_1 = require("./internal");
var internal_2 = require("../shared/internal");
var logger = null;
/**
 * Инициализация браузерного логгера
 *
 * @todo сделать для production другой транспорт (не консоль)
 *
 * @export
 * @returns {ILogger}
 */
function init() {
    if (logger) {
        return logger;
    }
    var config = browser_1.init();
    var application = config.getStrict('projectName');
    var version = config.getStrict('version');
    var baseUrl = config.get('logger.browser.baseUrl');
    var pathApi = config.get('logger.browser.pathApi');
    var messageWriter = new internal_2.ConsoleWriter();
    /**
     * Это сделано для того, чтобы локально ошибки сыпались только в консоль
     */
    var errorWriter = baseUrl && pathApi
        ? new internal_1.HttpTransport(createUrl(baseUrl, pathApi))
        : new internal_2.ConsoleWriter();
    logger = new internal_1.BrowserLogger({
        application: application,
        version: version,
        messageWriter: messageWriter,
        errorWriter: errorWriter,
        errorType: internal_1.EBrowserLogTypes.Error,
        messageType: internal_1.EBrowserLogTypes.Message,
    });
    return logger;
}
exports.init = init;
/**
 * Возвращает инстанс браузерного логгера. Если логгер был не инициализирован, то выбрасывает исключение
 *
 * @export
 * @returns {ILogger}
 */
function getLogger() {
    if (!logger) {
        throw new Error('Logger must be initialized before accessing it. Forgot to call init() before accessing logger?');
    }
    return logger;
}
exports.getLogger = getLogger;
function createUrl(base, path) {
    var url = urljoin(base, path);
    return url;
}
//# sourceMappingURL=interface.js.map